<template>
  <div>
    <banner img="/images/news.png" />
    <div class="main-content" v-loading="loading">
      <div class="model-name">项目动态</div>
      <div class="model-name-en">Project dynamics</div>
      <div class="tab-buttons">
        <div class="tab-button" :class="activeTab == item.id ? 'tab-button-active':''" @click="tabClick(item)"
          v-for="item in tabBtns" :key="item.id">{{item.typeName}}</div>
      </div>
      <template v-if="activeItem && activeItem.isType == 1">
        <VideoCenter :data="activeItem.articleDetailList" />
      </template>
      <template v-else-if="activeItem && activeItem.articleDetailList">
        <div class="hotspot-list">
          <div class="content-nav-item">
            <div class="item-list" v-for="(item, index) in activeItem.articleDetailList" :key="index">
              <div class="item-img" v-lazy:background-image="item.img || placeholderImg"></div>

              <p class="item-list-title more-t-2">{{item.title}}</p>
              <p class="item-list-content">{{item.brief}}</p>
              <div class="item-list-more">
                <a
                  href="javascript:;"
                  class="text-decoration"
                  @click="toArticleDetail(item)"
                >
                  <img src="../../assets/img/sanjiao.png" />
                  <span>查看更多</span>
                </a>
              </div>
            </div>
          </div>
          <!-- <el-row :gutter="10">
            <el-col :span="7" :offset="1" v-for="(item, index) in activeItem.articleDetailList" :key="index">
              <div class="hotspot-item">
                <div class="hotspot-item-time">{{parseTime(item.createTime, '{y}-{m}-{d}')}}</div>
                <div class="hotspot-item-name more-text" :title="item.title">
                  <a @click="toArticleDetail(item)">{{item.title}}</a>
                </div>
                <div class="hotspot-item-desc more-t-2">{{item.brief}}</div>
              </div>
            </el-col>
          </el-row> -->
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Banner from "../../components/Banner";
import VideoCenter from './components/VideoCenter'
import {
  parseTime
} from '@/utils/index'
import {
  loadYxTitle
} from '@/api/api'
export default {
  components: {
    Banner,
    VideoCenter
  },
  data() {
    return {
      activeTab: -1,
      activeItem: {
        articleDetailList: []
      },
      tabBtns: [
        // {
        //   typeName: '项目热点'
        // },
        // {
        //   typeName: '精彩活动'
        // },
        // {
        //   typeName: '媒体关注'
        // },
        // {
        //   typeName: '视频中心'
        // }
      ],
      loading: false,
      hotspotList: [
        {
          time: '2020.7.2',
          title: '20200702林业厅到现场了解公司种植，',
          brief: '20200702林业厅到现场了解公司种植，病虫害防治情况'
        },
        {
          time: '2020.7.1',
          title: '2020年7月1日主题教育｜参观红军长征粤…',
          brief: '2020年7月1日，中共韶关市友丰生态园林开发有限公司党支部全体党员及部分员工代表，在支部书记张克文的带领下,关市友丰生态园林开发有限公司党支部全体党员及部分'
        }
      ]
    };
  },
  created() {
    
  },
  mounted() {
    this.loadData()
  },
  methods: {
    parseTime,
    loadData() {
      loadYxTitle({
        titleId: 2
      }).then(res => {
        var data = res.content.find(item => {
          return item.titleType == 1
        })
        if(data) {
          this.tabBtns = data.articleTypeList
          if(data.articleTypeList.length > 0) {
            this.activeTab = data.articleTypeList[0].id
            this.activeItem = data.articleTypeList[0]
          }
        }
      })
    },
    toArticleDetail(item) {
      this.$router.push({
        name: 'article',
        params: {
          ...item
        }
      })
    },
    tabClick(item) {
      this.activeTab = item.id
      this.activeItem = item
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/color.scss';

.hotspot-item {
  height: 180px;
  .hotspot-item-time {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #999999;
    margin-bottom: 14px;
  }
  .hotspot-item-name {
    line-height: 24px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-bottom: 18px;
    cursor: pointer;
  }
  .hotspot-item-desc {
    padding-top: 20px;
    border-top: 1px solid #ECECEC;
    line-height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    color: #999999;
  }
}
.content-nav-item {
  width: 1070px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  //border: 1px solid blue;
  .item-list {
    width: 330px;
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px 10px;
    border: 1px solid $primary-color;
    &:hover {
      border: 1px solid #fff;
      box-shadow: 0 0 5px 2px #bfd3e0;
    }
    .item-img {
      width: 300px;
      height: 210px;
      background-color: #cecece;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
    }
    &-title {
      width: 300px;
      height: 60px;
      color: #15669e;
      font-size: 22px;
      padding: 0 10px;
      margin: 20px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      border-left: 1px solid #15669e;
    }
    &-content {
      width: 273px;
      height: 100px;
      font-size: 14px;
      color: gray;

      // 文本长度处理 begin
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      white-space: normal !important;
      word-wrap: break-word;
      // 文本长度处理 ending
    }
    &-more {
      width: 273px;
      padding-top: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        width: 12px;
        height: 12px;
      }
      span {
        color: #e13834;
        padding: 0 5px;
      }
    }
  }
}
</style>